import React, { useCallback } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import CatalogCategoryDropdown from '@/components/Dropdowns/CatalogCategoryDropdown';

function translateLabel(t, key, fallback) {
  const value = t(key);
  return value === key ? fallback : value;
}

function ExploreCategoryDropdown(props) {
  const { t } = useTranslation();

  const formatCountLabel = useCallback((count) => {
    if (typeof count !== 'number' || count <= 0) return null;
    if (count === 1) {
      return translateLabel(t, 'explore.categoryItemSingle', '1 item');
    }
    const tmpl = translateLabel(t, 'explore.categoryItems', '%COUNT% items');
    return tmpl.replace('%COUNT%', String(count));
  }, [t]);

  return (
    <CatalogCategoryDropdown
      {...props}
      allOptionLabel={translateLabel(t, 'explore.allCategories', 'All categories')}
      defaultTriggerLabel={translateLabel(t, 'explore.browseCategories', 'Categories')}
      scrollForMoreLabel={translateLabel(t, 'explore.scrollForMore', 'Scroll for more')}
      getCategoryCount={(cat) => cat?.stats?.itemCount}
      formatCountLabel={formatCountLabel}
      menuContentClassName="ExploreCategoryDropdown CatalogCategoryDropdown"
      menuScrollNativeId="explore-category-menu-scroll"
    />
  );
}

export default React.memo(ExploreCategoryDropdown);
